import { render, staticRenderFns } from "./AssignTypeByUserView.vue?vue&type=template&id=4269b7e3&"
import script from "./AssignTypeByUserView.vue?vue&type=script&lang=js&"
export * from "./AssignTypeByUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports